import { render, staticRenderFns } from "./JSelectAllrols.vue?vue&type=template&id=3bdeaf84&scoped=true"
import script from "./JSelectAllrols.vue?vue&type=script&lang=js"
export * from "./JSelectAllrols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdeaf84",
  null
  
)

export default component.exports